import axios from 'axios';
import { changeWords } from './const';
import trimStart from 'lodash/trimStart';

function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return '';
}

function getRememberPwd() {
  var cookieList = document.cookie.split(';');
  var res = [];
  cookieList.forEach(function(cookie) {
    if (cookie.indexOf('rememberpwd') !== -1) {
      var splitCookie = cookie.split('=');
      res.push({
        name: splitCookie[0].trim(),
        value: splitCookie[1]
      });
    }
  });
  return res;
}

/**
 * 请求 domain 接口
 */
export function requestDomain() {
  axios.interceptors.request.use(config => {
    config.headers.Cookies = 'CASTGC=' + getCookie('CASTGC') + ';CASTGCSpecial=' + getCookie('CASTGCSpecial') + ';';

    // 镜像环境额外设置一个 ForCASTGC
    if (window.domainConf) {
      const CookieName = window.domainConf.CookieName;
      config.headers.Cookies += `${CookieName}=${getCookie(CookieName)};`;
    }

    var cookieList = getRememberPwd();
    cookieList.forEach(function(cookie) {
      config.headers.Cookies += cookie.name + '=' + cookie.value + ';';
    });
    return config;
  });

  return axios.post('/Setting/domain', {
    path: ['search', 'S', 'fz', 'video', 'csite']
  });
}

/**
 * 执行检索操作，必须绑定 this
 * @param {searchWord, resourceType, searchUrl} data
 */
export function searchMethod(data) {
  const newQuery = {
    q: encodeURIComponent(data.searchWord)
  };
  const { query } = this.$route;
  // 页展示条数
  if (query.s) newQuery.s = query.s;
  // 列表样式
  if (query.style) newQuery.style = query.style;
  const route = {
    query: { ...newQuery }
  };
  route.path = data.newSUrl + data.resourceType;
  // 如果是S开发模式
  if (this.isDevelopment) {
    route.path = '/' + data.resourceType;
  }
  const { o } = query;
  let href;
  const { resourceType } = data;
  if (o && o.length > 0) {
    //对应资源查找  没有该排序字段不传 todo
    const objO = JSON.parse (o)
    // href = route.path + '?q=' + route.query.q + '&o=' + o;
    let obj = {
      paper: ['相关度', '出版时间', '被引频次'],
      periodical: ['相关度', '出版时间', '被引频次', '下载量'],
      magazine: ['相关度', '影响因子', '文献量', '被引频次','下载量'],
      thesis: ['相关度', '学位授予时间', '被引频次', '下载量'],
      conference: ['相关度', '出版时间', '被引频次', '下载量'],
      meeting: ['相关度', '时间', '文献量', '被引频次','下载量'],
      patent: ['相关度', '申请时间', '公开时间', '下载量'],
      nstr: ['相关度', '编制时间'],
      cstad: ['相关度', '成果级别', '公布年份'],
      standard: ['相关度', '发布日期'],
      claw: ['相关度', '下载量','颁布时间'],
      law: ['相关度', '下载量','颁布时间'],
      localchronicleitem: ['相关度', '出版日期'],
      localchronicle:['相关度', '出版日期'],
      video: ['相关度', '时间'],
    }
    let filterArr = obj[resourceType];
    if (objO.field && filterArr && filterArr.includes(objO.field)) {
      href = route.path + '?q=' + route.query.q + '&o=' + o;
    } else {
      href = route.path + '?q=' + route.query.q;
    }
  } else {
    href = route.path + '?q=' + route.query.q;
  }
  for (let key in route.query) {
    if (key !== 'q') {
      href += '&' + key + '=' + route.query[key];
    }
  }
  const pathname = window.location.pathname;
  if (pathname === '/topsearch') {
    window.open(href)
  } else {
   window.location.href = href;
  }
}

/**
 * 根据路由获取对应的类型，必须绑定 this，
 */
export function getCurrentType() {
  if (this.$route.path.indexOf('/periodical') >= 0) {
    return 'periodical';
  } else if (this.$route.path.indexOf('/thesis') >= 0) {
    return 'thesis';
  } else if (this.$route.path.indexOf('/conference') >= 0) {
    return 'conference';
  } else if (this.$route.path.indexOf('/patent') >= 0) {
    return 'patent';
  } else if (this.$route.path.indexOf('/cstad') >= 0) {
    return 'cstad';
  } else if (this.$route.path.indexOf('/standard') >= 0) {
    return 'standard';
  } else if (this.$route.path.indexOf('/claw') >= 0) {
    return 'law';
  } else if (this.$route.path.indexOf('/nstr') >= 0) {
    return 'nstr';
  } else if (this.$route.path.indexOf('/localChronicleItem') >= 0) {
    return 'localchronicleitem';
  } else if (this.$route.path.indexOf('/video') >= 0) {
    return 'video';
  } else {
    return 'paper';
  }
}

/**
 *
 * @param {*} type 资源类型
 * @param {*} searchWord 检索词
 */
export function getChangeSearchWord(type, searchWord) {
  // 规则：按空格拆分检索词，当做一个检索单元
  const swArr = searchWord.split(' ');
  const newSearchWordArr = [];
  swArr.forEach(unit => {
    // 规则：每个检索单元按:拆分，只把第一个:前面的内容作为字段，把它当做待替换字段
    let uArr = unit.split(':');
    if (unit.indexOf(':') === -1) {
      // 中文冒号
      uArr = unit.split('：');
    }
    const field = uArr[0];
    if (field) {
      for (let keyStringList in changeWords[type]) {
        // 把 key 再按照 | 拆出来
        const keyArrayList = keyStringList.split('|');
        if (keyArrayList.indexOf(field) !== -1) {
          if (changeWords[type][keyStringList] !== '') {
            uArr[0] = changeWords[type][keyStringList];
          } else {
            uArr[0] = '';
          }
          break;
        }
      }
    }
    const newUnit = trimStart(uArr.join(':'), ':');
    newSearchWordArr.push(newUnit);
  });
  return newSearchWordArr.join(' ');
}

/**
 * 校验检索词是否合法（是否只包含特殊符号）
 * @param {String} data 检索词
 */
export function checkSearchWord(data) {
  // const reg = /(?:[\u3400-\u4DBF\u4E00-\u9FFC\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDD\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD884[\uDC00-\uDF4A])|[a-zA-Z0-9]/g;
  const reg = /[~!@#$%^&*()<>_+\-?/\\\s]/g;
  const rep = data.replace(reg, function() {
    return '';
  });
  if (rep.length === 0) {
    return false;
  }
  // if (reg.test(data)) {
  //   return true;
  // }
  return true;
}

/**
 * 替换检索词中的 *、+ 和 ^
 * @param {String} searchWord 检索词
 */
// export function filterSearchWord(searchWord) {
//   let tmpSearchWord = searchWord;

//   // 保留双引号里的内容
//   let i = 0;
//   let tmpArr = [];
//   tmpSearchWord = tmpSearchWord.replace(/(".*?")/g, match => {
//     let str = '${' + i + '}';
//     tmpArr.push(match);
//     i++;
//     return str;
//   });

//   // 保留 Date: 表达式内容
//   const dateMatch = /([Dd]ate:(\*|\d{4})-(\*|\d{4}))/.exec(tmpSearchWord);
//   let dateStr = '';
//   if (dateMatch) {
//     dateStr = dateMatch[0];
//     tmpSearchWord = tmpSearchWord.replace(dateStr, '${date}');
//   }

//   // 保留两个加号
//   if (/([+]{2})/g.test(searchWord)) {
//     tmpSearchWord = tmpSearchWord.replace(/([+]{2})/g, '${plus}');
//   }

//   tmpSearchWord = tmpSearchWord.replace(/(\s*\*\s*)|(\s*\^\s*)|(\s*\+\s*)/g, (match, and, not, or) => {
//     if (and) return ' and ';
//     if (not) return ' not ';
//     if (or) return ' or ';
//   });
//   // 按倒序来还原
//   tmpSearchWord = tmpSearchWord.replace('${plus}', '++');
//   tmpSearchWord = tmpSearchWord.replace('${date}', dateStr);
//   if (tmpArr.length > 0) {
//     let j = 0;
//     tmpSearchWord = tmpSearchWord.replace(/(\$\{\d\})/g, () => {
//       let str = tmpArr[j];
//       j++;
//       return str;
//     });
//     tmpArr = [];
//   }
//   return tmpSearchWord;
// }
